import Xarrow from "react-xarrows";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

function ManualDef2({ setTutorial }) {
  const renderTrigger = useArrowSync();

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("add_input_parameter") && (
        <div className={`${styles["container"]} ${styles["container-2"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-2"
            className={`${styles["container__text"]} ${styles["container__text-2"]}`}>
            <p>Click here to add your first parameter</p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-2"
            end="add_input_parameter"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-2"]} ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Time to add you first parameter! Click 'Add Input Parameter' to begin. You can type a
              name yourself, or pause for a moment to let the AI suggest one for you.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualDef2;
